import React from 'react'
import card4 from '../assets/arteDeImpactar.png'

const Card4 = () => {
  return (
    <div className='animasion2  formStyle lg:'>
      <div className=" py-4">
        <p>
         Paloma Patrícia é psicóloga graduada pela 
        Universidade de Ribeirão Preto e pós-graduada 
        pelo Instituto de Estudos e Comportamento Psicológico.
         Formada em Psicologia Positiva pela Sociedade 
         Brasileira de Coaching, altamente preparada para 
         ajudar você a atingir as metas, potencializar seus 
         resultados e mudar os rumos de sua vida, através de 
         técnicas cientificamente comprovadas.
        </p>
      </div>
    </div>
  )
}
export default Card4